import { render } from "./OrderSent.vue?vue&type=template&id=0e3524bd&ts=true"
import script from "./OrderSent.vue?vue&type=script&lang=ts"
export * from "./OrderSent.vue?vue&type=script&lang=ts"

import "./OrderSent.vue?vue&type=style&index=0&id=0e3524bd&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/payment/OrderSent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e3524bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e3524bd', __exports__)) {
    api.reload('0e3524bd', __exports__)
  }
  
  module.hot.accept("./OrderSent.vue?vue&type=template&id=0e3524bd&ts=true", () => {
    api.rerender('0e3524bd', render)
  })

}


export default __exports__